var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import './SimpleSection';
let ComponentSection = class ComponentSection extends LitElement {
    render() {
        return html `
      <simple-section .title=${this.title}>
        <div class="component-list">
          ${this.components.map(c => html `<light-component-card .component=${c}></light-component-card>`)}
        </div>
      </simple-section>
    `;
    }
};
ComponentSection.styles = css `
    :host {
      display: block;
    }
    .component-list {
      display: flex;
      flex-direction: column;
      gap: 9px; /* Réduction de 25% */
    }
  `;
__decorate([
    property({ type: String })
], ComponentSection.prototype, "title", void 0);
__decorate([
    property({ type: Array })
], ComponentSection.prototype, "components", void 0);
ComponentSection = __decorate([
    customElement('component-section')
], ComponentSection);
export { ComponentSection };
//# sourceMappingURL=ComponentSection.js.map